module.exports = __webpack_public_path__ + "img/sameday_dfod_dg_k.e088a8fd.png";